document.addEventListener('turbolinks:load', function () {
     // off() first: this runs every Turbolinks visit and would otherwise stack another handler on document
     $(document).off('change.radioCard').on('change.radioCard', ".radio-button-card input[type='radio']", function () {
        $('.radio-button-card').removeClass('selected')
        if ($(this).prop('checked')) {
            $(this).parent().addClass('selected')
        } else {
            $(this).parent().removeClass('selected')
        }
    })
});